<div class="highcharts-tooltip">
  <span>
    <div>
      <span
        class="metric-tooltip title school_comp_title capitalize tile_body calendar-title"
        >{{ date }}</span
      >
      <span
        class="metric-tooltip value school_comp_value tooltip_value calendar-title"
        >{{ value
        }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container></span
      >
    </div>
    <div class="body_tooltip_text subtitle">
      Shows daily result, not year-to-date
    </div>
    <div
      class="metric-tooltip school_comp_description body_tooltip_text calendar-descriptor"
    >
      <strong>{{ numerator | number }}</strong>
      <ng-container *ngIf="denominator">
        of
        <strong>{{ denominator | number }}</strong>
      </ng-container>
      {{ descriptor }}
    </div>
  </span>
</div>
